import * as React from 'react'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'

interface IProgressBarProps extends RouteComponentProps<{}> {}

const ProgressBar: React.SFC<IProgressBarProps> = (
  props: IProgressBarProps
) => {
  const { pathname } = props.location
  const pathSlug = pathname.split('/').slice(-1)[0]

  const stageList = [
    { slug: 'new', label: 'Select', link: '/views/new' },
    {
      slug: 'factoids',
      label: 'How we help',
      link: '/views/new/factoids'
    },
    { slug: 'review', label: "What's next", link: '/views/new/review' }
  ]

  const stages: string[] = []

  switch (pathSlug) {
    case 'new':
      stages.push('new')
      break
    case 'factoids':
      stages.push('new', 'factoids')
      break
    case 'review':
      stages.push('new', 'factoids', 'review')
  }

  const items = stageList.map((stage, i): React.ReactNode => {
    // @ts-ignore
    const active = stages.includes(stage.slug)
    return (
      <Item key={i} className={active ? 'is-active' : ''}>
        {active ? <Link to={stage.link}>{stage.label}</Link> : stage.label}
      </Item>
    )
  })

  return (
    <Container>
      <List>{items}</List>
    </Container>
  )
}

export default withRouter(ProgressBar)

const Container = styled.div`
  margin-top: 66px;
  max-width: 100vw;
  width: 100vw;
  background-color: #fafafa;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 599px) {
    margin-top: 50px;
  }
`

const List = styled.ul`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 100%;
  height: 100%;
  overflow: hidden;
`

const Item = styled.li`
  flex: 1;
  position: relative;
  text-align: center;
  font-size: 15px;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 0.9px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a3a3a3;

    a {
      font-weight: 400;
      color: #5fbbca !important;
    }

  &:not(:last-child) {
    &:after {
    display: block;
    position: absolute;
    content: '';
    z-index: 999;
    border: 25px solid transparent;
    border-left-color: #fafafa;
    top: 0px;
    right: -50px;
  }


  &.is-active,
  &.first-active {
    background-color: #efefef;



    &:after {
      border-left-color: #efefef;
    }
    &:before {
      display: block;
      position: absolute;
      content: '';
      z-index: 999;
      border: 25px solid transparent;
      border-left-color: #d6d6d6;
      top: 0px;
      right: -52px;
    }
  }
  }

  @media screen and (max-width: 375px) {
    font-size: 9.5px;
  }

  @media screen and (max-width: 713px) {
    font-size: 12px;
  }

  &:last-child {

    &.is-active {
        background-color: #efefef;

    &:after {
      border-left-color: #efefef;
    }
    }
    &:after {
        display: block;
        position: absolute;
        content: '';
        z-index: 999;
        border: 25px solid transparent;
        border-left-color: #fafafa;
        top: 0px;
        right: -25px;
    }
    &:before {
        height: 100%;
    background-color: #F9F9F9;
    width: 25px;
    display: block;
    position: absolute;
    content: '';
    z-index: 999;
    top: 0px;
    right: 0px;
}
    }
  }
  &:nth-child(2) {
    padding-left: 15px;
  }
`



// WEBPACK FOOTER //
// ./src/shared/ProgressBar.tsx